<template>
  <div class="crosswork">
    <div class="crosswork-container">
      <div class="row">
        <div class="col-8">
          <div class="row">
            <div class="col-5">
              <div class="subtext-1">Partnering with:</div>
              <img
                src="@/images/investment/crosswork.png"
                class="image-title"
              />
            </div>
            <div class="col-7">
              <p>
                In preparation for a liquidity event we have partnered with
                CrossWork.us a leading pre- IPO group with a track record of
                many pre-IPO success stories and multiple executives that have
                taken companies public
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {};
</script>
